module.exports = __webpack_public_path__ + "img/workspace-onboarding/install-chrome-extension-rebrand-83d00896b0dd0e6a68dbfff4df3c11d2.png";